import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/roleMappingRule.ts
const listRoleMappingRules = async (context) => {
	const response = await makeRestApiRequest(context, "GET", "/role-mapping-rule");
	return response.items ?? response;
};
const createRoleMappingRule = async (context, input) => {
	return await makeRestApiRequest(context, "POST", "/role-mapping-rule", input);
};
const updateRoleMappingRule = async (context, id, patch) => {
	return await makeRestApiRequest(context, "PATCH", `/role-mapping-rule/${id}`, patch);
};
const deleteRoleMappingRule = async (context, id) => {
	await makeRestApiRequest(context, "DELETE", `/role-mapping-rule/${id}`);
};
const moveRoleMappingRule = async (context, id, targetIndex) => {
	return await makeRestApiRequest(context, "POST", `/role-mapping-rule/${id}/move`, { targetIndex });
};

//#endregion
export { updateRoleMappingRule as a, moveRoleMappingRule as i, deleteRoleMappingRule as n, listRoleMappingRules as r, createRoleMappingRule as t };
//# sourceMappingURL=roleMappingRule.mjs.map